import { Pipe, PipeTransform } from "@angular/core";
import {parsePhoneNumberWithError, ParseError } from "libphonenumber-js/min";

@Pipe({
    name: "phoneNumber",
})
export class PhoneNumberPipe implements PipeTransform {
    transform(value: string | undefined | null, ...args: string[]): any {
        try {
            const phoneNumber = parsePhoneNumberWithError(value);
            return phoneNumber.isValid() ? phoneNumber.format('INTERNATIONAL') : value;
        } catch (error) {
            if (error instanceof ParseError) {
                console.log(error.message)
            }
            return value;
        }
    }
}
